import {useSelector} from 'react-redux';

import insightTileService from '@/services/experienceScore/insightTileService';
import {selectExperienceInsightsAndTips, selectExperienceTipsToConsider} from '@/state/selectors/inference';
import {selectIsRetail} from '@/state/selectors/insights';

const useInsightTiles = () => {
    const insightsAndTips = useSelector(selectExperienceInsightsAndTips);
    const tipsToConsider = useSelector(selectExperienceTipsToConsider);
    const isRetail = useSelector(selectIsRetail);

    return insightTileService.getInsightTiles({insightsAndTips, tipsToConsider, isRetail});
};

export default useInsightTiles;
